/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import { SelectControl } from '@wordpress/components';
import { __experimentalNumberControl as NumberControl } from '@wordpress/components';

/**
 * Imports the InspectorControls component, which is used to wrap
 * the block's custom controls that will appear in in the Settings
 * Sidebar when the block is selected.
 *
 * Also imports the React hook that is used to mark the block wrapper
 * element. It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#inspectorcontrols
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';

/**
 * Imports the necessary components that will be used to create
 * the user interface for the block's settings.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/components/panel/#panelbody
 * @see https://developer.wordpress.org/block-editor/reference-guides/components/text-control/
 * @see https://developer.wordpress.org/block-editor/reference-guides/components/toggle-control/
 */
import { PanelBody, TextControl, ToggleControl } from '@wordpress/components';

/**
 * Imports the useEffect React Hook. This is used to set an attribute when the
 * block is loaded in the Editor.
 *
 * @see https://react.dev/reference/react/useEffect
 */
import { useEffect } from 'react';

const CAMPAIGN_OPTIONS = charitable_block_data;

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @param {Object}   props               Properties passed to the function.
 * @param {Object}   props.attributes    Available block attributes.
 * @param {Function} props.setAttributes Function that updates individual attributes.
 *
 * @return {Element} Element to render.
 */
export default function Edit( { attributes, setAttributes } ) {
	const { includeRecurring } = attributes;

	useEffect( () => {
		if ( includeRecurring === undefined || includeRecurring === null || includeRecurring === '' ) {
			setAttributes( { includeRecurring: 1 } );
		}
	}, [ includeRecurring, setAttributes ] );

	return (
		<>
			<InspectorControls>
				<PanelBody
					title={ __( 'Settings', 'charitable' ) }
				>
					<ToggleControl
						label={ __( 'Include Recurring Donations', 'charitable' ) }
						checked={ includeRecurring }
						onChange={ ( value ) =>
							setAttributes( { includeRecurring: value } )
						}
						help={ __(
							'If you have the Recurring Donations addon enabled, enable this to include recurring donations in the display.',
							'charitable'
						) }
					/>
					<p className="wpchar-gutenberg-panel-notice">
						<strong>{ charitable_block_data.panel_my_donations_notice_head }</strong>
						{ charitable_block_data.panel_my_donations_notice_text }
						<a href={ charitable_block_data.panel_my_donations_notice_link } rel="noreferrer" target="_blank">{ charitable_block_data.panel_my_donations_notice_link_text }</a>
					</p>


				</PanelBody>
			</InspectorControls>
			<div { ...useBlockProps() }>
				<div
					className="charitable-block charitable-logo">
					<img src={ charitable_block_data.logo } />
				</div>
				<h5>{ __( 'My Donations', 'charitable' ) }</h5>
				<p>{ __( 'Preview Not Available In Editor', 'charitable' ) }</p>
			</div>
		</>
	);
}
